import * as React from "react";
import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    OverlayDrawer,
    Button,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import CounterBadge from "../counterBadge/CounterBadge";

const Drawer = (props) => {
    const { DrawerTrigger, DrawerTitle, DrawerBodyArea } = props;
    const [isOpen, setIsOpen] = React.useState(false);


    React.useEffect(() => {
        const data = document.getElementsByClassName("fui-FluentProvider")
        Object.values(data).map((item, index) => {
            if (index === Object.values(data).length - 1) {
                item.style.zIndex += 1
            }
        })
    }, [isOpen])

    return (
        <div >
            <OverlayDrawer
                className="DrawerOverlay"
                modalType="non-modal"
                position="end"
                open={isOpen}
                onOpenChange={(_, { open }) => setIsOpen(open)}
            >
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="Close"
                                icon={<Dismiss24Regular />}
                                onClick={() => setIsOpen(false)}
                            />
                        }
                    >
                        {DrawerTitle}
                        {DrawerTitle === 'Notifications' && <CounterBadge StyleClass="CounterBadgeWrap_small" BadgeSize="medium" />}
                    </DrawerHeaderTitle>
                </DrawerHeader>

                <DrawerBody>
                    {DrawerBodyArea}
                </DrawerBody>

            </OverlayDrawer>

            <div onClick={() => setIsOpen(!isOpen)}>
                {DrawerTrigger}
            </div>
        </div>
    );
};

export default Drawer;